export function sanitiseData(storyData) {
  // this is going to be messy, I'm here for it
  if (!storyData.settings) {
    storyData.settings = {
      saveInterval: 30,
      snapGrid: true,
      displayGrid: true,
    };
  }
  if (!storyData.extra) {
    storyData.extra = {
      lastSave: "",
    };
  }

  if (!storyData.loc.na) {
    let templateKey = null;
    for (const key in storyData.loc) {
      if (key !== "na") {
        templateKey = key;
        break;
      }
    }

    if (templateKey) {
      const template = storyData.loc[templateKey];
      const newNaContent = {};

      for (const lang in template) {
        newNaContent[lang] =
          "Language " + (Object.keys(newNaContent).length + 1);
      }

      storyData.loc.na = newNaContent;
    } else {
      storyData.loc.na = {
        en: "English",
      };
    }
  }

  return storyData;
}
